// Mercado entre jogadores, igual ao Market do Tibia Global (regras compartilhadas entre servidor e navegador):
// ofertas de venda e de compra por gold, aceitar oferta de outro jogador, ofertas anônimas, histórico e estatísticas.
// As Noxara Coins só são negociadas aqui, por gold, como as Tibia Coins no Global.
import type { Affix } from './affixes.js';

export type MarketSide = 'sell' | 'buy';
/** moeda da oferta: gold (banco do personagem) ou Noxara Coins (da conta) — decisão do Arthur, 15/10 */
export type MarketCurrency = 'gold' | 'coins';
export interface MarketOffer {
  id: number; side: MarketSide; sellerId: number; seller: string; kind: 'item' | 'coins';
  typeId: number; count: number; rarity: number; price: number; at: number; currency: MarketCurrency;
  affixes?: Affix[]; upgrade?: number; charges?: number; anonymous?: boolean;
}
export interface MarketHistoryRow { side: MarketSide; kind: 'item' | 'coins'; typeId: number; count: number; rarity: number; price: number; currency: MarketCurrency; state: 'completed' | 'cancelled' | 'expired'; at: number }
export interface MarketStatSide { transactions: number; total: number; highest: number; average: number; lowest: number }
export interface MarketStats { typeId: number; sell: MarketStatSide; buy: MarketStatSide; /** negócios fechados em Noxara Coins */ coins: { sell: MarketStatSide; buy: MarketStatSide } }

/** Ofertas abertas por personagem (o Tibia permite 100). */
export const MARKET_MAX_OFFERS = 100;

/** Taxa do anúncio: 5% do valor total (decisão do Arthur, contra a inflação), mínimo 20 gp e máximo 1.000.000 gp. */
export const MARKET_FEE_PCT = 5;
export function marketFee(total: number, currency: MarketCurrency = 'gold'): number {
  if (currency === 'coins') return Math.max(1, Math.floor(total * MARKET_FEE_PCT / 100));   // em coins: 5%, mínimo 1
  return Math.max(20, Math.min(1_000_000, Math.floor(total * MARKET_FEE_PCT / 100)));
}
/** valor com a moeda: "1.500 gp" ou "30 Noxara Coins" */
export const curText = (n: number, c: MarketCurrency) => `${n.toLocaleString('pt-BR')} ${c === 'coins' ? 'Noxara Coins' : 'gp'}`;
/** Ofertas valem 7 dias (decisão do Arthur, 15/10); depois voltam (item para o depot, coins para a conta, gold reservado para o banco).
 *  Cancelar pode a qualquer momento, sem devolver a taxa. */
export const MARKET_OFFER_DAYS = 7;
/** As Noxara Coins aparecem no mercado como este item. */
export const MARKET_COIN_ITEM = 22118;
export const MARKET_MAX_PRICE = 999_999_999;

/** Categorias do Market do Tibia (ids do campo "market" dos itens, os mesmos do cliente oficial). Sem Runas: elas são cobradas por uso (decisão do Arthur, 15/10). */
export const MARKET_CATEGORIES: Array<{ id: number; label: string; group?: string }> = [
  { id: 1, label: 'Armaduras' }, { id: 2, label: 'Amuletos' }, { id: 3, label: 'Botas' }, { id: 4, label: 'Recipientes' },
  { id: 24, label: 'Produtos de criaturas' }, { id: 5, label: 'Decoração' }, { id: 6, label: 'Comida' }, { id: 7, label: 'Capacetes e chapéus' },
  { id: 8, label: 'Calças' }, { id: 9, label: 'Outros' }, { id: 10, label: 'Poções' }, { id: 25, label: 'Aljavas' }, { id: 11, label: 'Anéis' },
  { id: 13, label: 'Escudos' }, { id: 23, label: 'Noxara Coins' }, { id: 26, label: 'Soul Cores' }, { id: 14, label: 'Ferramentas' }, { id: 15, label: 'Valiosos' },
  { id: 16, label: 'Munição', group: 'Armas' }, { id: 17, label: 'Machados', group: 'Armas' }, { id: 18, label: 'Clavas', group: 'Armas' },
  { id: 19, label: 'Distância', group: 'Armas' }, { id: 20, label: 'Espadas', group: 'Armas' }, { id: 21, label: 'Varinhas e cetros', group: 'Armas' },
  { id: 27, label: 'Armas de punho', group: 'Armas' },
];
/** categoria do item no mercado (as Noxara Coins têm a delas) */
export function marketCategory(t: { id: number; market?: number }): number | undefined {
  if (t.id === MARKET_COIN_ITEM) return 23;
  const c = t.market;
  return c && MARKET_CATEGORIES.some((x) => x.id === c) ? c : undefined;
}
